import { useLocation, useOutlet, useNavigationType } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * Drop-in replacement for <Outlet /> that animates page transitions.
 *
 * Uses mode="wait" (exit completes before enter) with a short 200ms
 * ease-out animation. Direction is inferred from the navigation type:
 *   PUSH → slide in from right, exit to left
 *   POP  → slide in from left, exit to right
 *
 * Only used for sub-page routes (settings, profile, detail pages).
 * Tab routes continue to use instant CSS visibility toggling via TabView.
 */
export function AnimatedOutlet() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const outlet = useOutlet();

  const isBack = navigationType === 'POP';

  return (
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.div
        key={location.pathname}
        layout
        initial={{ x: isBack ? '-5%' : '5%', opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: isBack ? '5%' : '-5%', opacity: 0 }}
        transition={{ duration: 0.15, ease: [0.25, 0.1, 0.25, 1.0] }}
        className="h-dvh flex flex-col"
      >
        {outlet}
      </motion.div>
    </AnimatePresence>
  );
}
